<script>
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import {mapGetters} from 'vuex';
import {PdlLoading} from '@pedal/pdl-loading';
import {PdlCallout} from '@pedal/pdl-callout';
import TrekButton from '@/components/TrekButton';
import CartSummary from '@/components/cart/CartSummary';
import {PdlTabs, PdlTabPane} from '@pedal/pdl-tabs';
import {PdlCollapse} from '@pedal/pdl-collapse';
import Warehouse from '@/components/containers/checkout/Warehouse';
import ElDialog from '@/components/Dialog';
import warehouse from '@/mixins/warehouse';
import {flattenAllocatedItems} from '@/utils/allocated-items-helpers';

export default {
  components: {PdlLoading, PdlCallout, TrekButton, CartSummary, PdlTabs, PdlTabPane, PdlCollapse, Warehouse, ElDialog},

  mixins: [warehouse],

  provide() {
    return {
      container: this,
    };
  },

  props: {
    textBikes: {
      type: String,
      default: 'Bikes',
    },
    textAccessories: {
      type: String,
      default: 'Accessories',
    },
  },

  data() {
    return {
      cartData: {
        bikes: {
          warehouses: [],
        },
        parts: {
          warehouses: [],
        },
        cartSummary: {},
      },
      calculatedFreight: {
        bikes: false,
        parts: false,
      },
      loading: true,
      types: ['bikes', 'parts'],
      selectedTabName: '',
      accessoriesTabChecked: false,
      dialogVisible: false,
      targetUrl: '',
      hasCheckedAllocatedItems: false,
    };
  },

  computed: {
    bikes() {
      return this.cartData.bikes;
    },

    parts() {
      return this.cartData.parts;
    },

    bikeWarehouseIds() {
      return this.getWarehouseIds('bikes');
    },

    partWarehouseIds() {
      return this.getWarehouseIds('parts');
    },

    tabSelected: {
      get() {
        return this.selectedTabName || (!isEmpty(this.bikes) && this.bikes.totalAllocatedQty ? 'bikes' : 'parts');
      },
      set(name) {
        this.selectedTabName = name;
      },
    },

    isHoldOrder() {
      return (this.bikes && this.bikes.hold) || (this.parts && this.parts.hold);
    },

    isHoldBikesOnly() {
      return this.bikes && this.bikes.hold && (!this.parts || !this.parts.hold);
    },

    isHoldPartsOnly() {
      return (!this.bikes || !this.bikes.hold) && this.parts && this.parts.hold;
    },

    isHoldAllOrder() {
      return this.bikes && this.bikes.hold && this.parts && this.parts.hold;
    },

    bikesAndParts() {
      return {bikes: this.bikes, parts: this.parts};
    },

    showReviewLink() {
      return (
        this.isHoldAllOrder ||
        (this.isHoldBikesOnly && !this.hasAllocatedParts) ||
        (this.isHoldPartsOnly && !this.hasAllocatedBikes)
      );
    },

    hasAllocatedBikes() {
      return this.bikes && this.bikes.totalAllocatedQty;
    },

    hasAllocatedParts() {
      return this.parts && this.parts.totalAllocatedQty;
    },
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  async mounted() {
    await this.loadCart();
    if (!this.hasCheckedAllocatedItems && !this.$store.getters['storage/hasUserTouchedAllocatedItems']) {
      await this.loadTotals();
    }
  },

  methods: {
    cartSummaryLoaded(cartSummaryEl) {
      this.enableSubmitListeners(cartSummaryEl);
    },

    proceedToUrl() {
      window.location = this.targetUrl;
    },

    enableSubmitListeners(cartSummaryEl) {
      if (!cartSummaryEl) {
        return;
      }
      $(cartSummaryEl)
        .find('.js-shipments-listener')
        .click(
          $.proxy(function(event) {
            if (event.currentTarget.dataset.link !== null) {
              this.targetUrl = event.currentTarget.dataset.link;
            } else {
              this.targetUrl = event.currentTarget.href;
            }
            event.preventDefault();
            if (this.targetUrl.includes('order-review')) {
              const itemsToUpdate = this.fillSelectedAllocatedItems(this.cartData);
              axios
                .put('/checkout-b2b/api/allocated-items/update-items', itemsToUpdate)
                .catch((error) => console.log(error));
            }
            // The dialog should only appear if we're moving to order review stage (and not back to shipments)
            // and both tabs are present yet the second one is not visited yet
            if (
              this.targetUrl.includes('order-review') &&
              !this.accessoriesTabChecked &&
              this.bikes.totalAllocatedQty &&
              this.parts.totalAllocatedQty
            ) {
              this.dialogVisible = true;
            } else {
              this.proceedToUrl();
            }
          }, this)
        );
    },

    tabClicked(paneName) {
      this.tabSelected = paneName;
      if (paneName == 'parts') this.accessoriesTabChecked = true;
    },

    updateCartSummary(cartSummary) {
      this.cartData.cartSummary = cartSummary;
    },

    changeGridTab(tab) {
      this.tabSelected = tab;
      if (tab == 'parts') this.accessoriesTabChecked = true;

      $('html, body').animate(
        {
          scrollTop: $(this.$refs.checkoutTabs.$el).offset().top - 150,
        },
        500
      );
    },

    getWarehouseIds(type) {
      if (!this[type] || !this[type].warehouses) return [];

      return this[type].warehouses.reduce((allWarehouseIds, warehouse) => {
        return [...allWarehouseIds, `${type}-${warehouse.id}`];
      }, []);
    },

    submitForm() {
      console.table(this.cartData.bikes);
    },

    getTabText(productType) {
      if (productType === 'bikes') return this.textBikes;
      if (productType === 'parts') return this.textAccessories;

      return '';
    },

    getFreightWarehouseData(warehouses) {
      if (isEmpty(warehouses)) return [];

      return map(warehouses, (warehouse) => {
        return {
          id: warehouse.id,
          isBackOrdered: false,
        };
      });
    },

    getFreightObject() {
      let data = {bikes: {}, parts: {}};

      data['isAllocatedItemsPage'] = true;
      if (this.cartData.bikes) {
        data.bikes['warehouses'] = this.getFreightWarehouseData(this.bikes.warehouses);
      }

      if (this.cartData.parts) {
        data.parts['warehouses'] = this.getFreightWarehouseData(this.parts.warehouses);
      }
      return data;
    },

    getAllocatedItemsObject() {
      const allocatedItems = flattenAllocatedItems(this.cartData);
      return allocatedItems.filter(item => item.selected).map(item => {
        return {
              sku: item.sku,
              quantity: item.quantityAllocatedOrShipped,
              totalPrice: item.lineSubtotalRaw,
              groupingType: ({
                'Bikes': 'BIKE',
                'Accessories': 'AFTERMARKET',
              })[item.productType],
        };
      });
    },

    recalculateFreight(cartType) {
      axios
        .put('/cart/freight', this.getFreightObject())
        .then(() => {
          this.loadTotals().finally(() => {
            this.calculatedFreight[cartType] = true;
          });
        })
        .catch((error) => console.log(error));
    },

    loadCart() {
      return axios
        .get('/checkout-b2b/api/allocated-items/items')
        .then(({data}) => {
          this.cartData = data;
          const allocatedItems = flattenAllocatedItems(data);
          this.hasCheckedAllocatedItems = allocatedItems.some(allocatedItem => allocatedItem.selected);
          if(!this.hasCheckedAllocatedItems && !this.$store.getters['storage/hasUserTouchedAllocatedItems']) {
            allocatedItems.forEach(allocatedItem => allocatedItem.selected = true)
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
        });
    },

    loadTotals() {
      return axios
        .put('/checkout/multi/allocated-items/totals/', this.getAllocatedItemsObject())
        .then(({data}) => {
          this.cartData.cartSummary.total = data.data.prices.totalPrice.formattedValue;

          const convertResponseItems = [
            [this.cartData.cartSummary.bikes, data.data.subTotals.BIKE],
            [this.cartData.cartSummary.parts, data.data.subTotals.AFTERMARKET]
          ];

          convertResponseItems.forEach(([componentData, responseData]) => {
            if(responseData) {
              componentData.totalItems = responseData.quantity;
              for(const [priceType, price] of Object.entries(responseData.prices)) {
                componentData[priceType] = price.formattedValue || componentData[priceType];
              }
            }
          });
        })
        .catch((error) => console.log(error));
    },

    navigateTo(url) {
      window.location.href = url;
    },
  },
};
</script>
